import type { FC, ReactNode } from 'react';
import { Box, type BoxProps, Flex } from '@eqi-investimentos/react';
export const CardFlipHorizontal: FC<CardFlipHorizontalProps> = ({
  showBack,
  frontFace,
  backFace,
  ...props
}) => <Box transform="perspective(62.5rem)" w="5.5625rem" minH="9.375rem" {...props} data-sentry-element="Box" data-sentry-component="CardFlipHorizontal" data-sentry-source-file="index.tsx">
    <Box pos="relative" w="full" h="full" transition="transform 0.6s" transform={showBack ? 'rotateY(180deg)' : ''} sx={{
    transformStyle: 'preserve-3d'
  }} data-sentry-element="Box" data-sentry-source-file="index.tsx">
      <Flex pos="absolute" flexFlow="column" alignItems="center" justifyContent="center" w="full" h="full" sx={{
      backfaceVisibility: 'hidden'
    }} data-sentry-element="Flex" data-sentry-source-file="index.tsx">
        {frontFace}
      </Flex>
      <Flex pos="absolute" flexFlow="column" alignItems="center" justifyContent="center" w="full" h="full" transform="rotateY(180deg)" sx={{
      backfaceVisibility: 'hidden'
    }} data-sentry-element="Flex" data-sentry-source-file="index.tsx">
        {backFace}
      </Flex>
    </Box>
  </Box>;
type CardFlipHorizontalProps = Omit<BoxProps, 'children'> & {
  backFace: ReactNode;
  frontFace: ReactNode;
  showBack: boolean;
};